// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.parent {\n    overflow: hidden;\n    position: relative;\n}\n.switch-contents {\n    display: flex;\n    flex-direction: row;\n    transition: .35s all cubic-bezier(0.59, 0.12, 0.34, 0.95);\n}\n.switch-content {\n    width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
